// extracted by mini-css-extract-plugin
module.exports = {"root":"MetadataFormHeader_root__1V2Xj","status":"MetadataFormHeader_status__NYRW8"};